import { Injectable } from "@angular/core";
import { IPRFISpecification } from "../api-generated";
import BaseService from "./base.service";

@Injectable({
  providedIn: "root",
})
export default class LocalSpecificationService extends BaseService<IPRFISpecification> {}
